function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FB4246",
  d: "M0 0h91v90H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#mobile-menu_svg__clip0_789_61)",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinejoin: "bevel"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 55.5h31.5M32 45h31.5M32 34.5h31.5"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "mobile-menu_svg__clip0_789_61"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "rotate(90 17.5 44.5)",
  d: "M0 0h36v36H0z"
})));

function SvgMobileMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 91 90",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgMobileMenu;